import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting later Tailwind classes win over earlier ones.
 * Without twMerge, `cn('p-2', 'p-4')` emits both and the winner depends on
 * stylesheet order — which is how "why won't this padding change" bugs start.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
